import moment from 'moment';
import React from 'react';
import { View } from 'react-native';
import { Icon, User } from '..';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export function Review({ name, rating, review, profile, style, createdAt }) {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Text, { type: 'headline', size: 'lg' }, name),
        rating ? (React.createElement(View, { style: styles.ratingContainer }, new Array(5).fill(0).map((_, i) => {
            return (React.createElement(Icon, { key: i, name: 'star', size: 14, filled: true, color: (c) => (i < rating ? c.warning.solid : c.invert2.p10) }));
        }))) : null,
        React.createElement(Text, { type: 'body', size: 'lg', weight: 'regular', style: styles.review, numberOfLines: 3, ellipsizeMode: 'tail' }, review),
        React.createElement(View, { style: styles.footer },
            React.createElement(User, Object.assign({ size: 'sm' }, profile)),
            React.createElement(Text, { type: 'body', size: 'lg', weight: 'semibold', style: styles.name }, profile.name),
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.date }, moment(createdAt).fromNow()))));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        padding: size.K,
        borderRadius: size.G,
        backgroundColor: color.invert2.p4,
        borderWidth: 1,
        borderColor: color.invert2.p4,
        flex: 1
    },
    ratingContainer: {
        marginTop: size.B,
        flexDirection: 'row'
    },
    review: {
        marginVertical: size.G
    },
    footer: {
        borderTopWidth: 1,
        borderTopColor: color.invert2.p4,
        paddingTop: size.G,
        flexDirection: 'row',
        alignItems: 'center'
    },
    name: { marginLeft: size.C, flex: 1 },
    date: { color: color.invert2.p56 }
}));
//# sourceMappingURL=index.js.map